
// import { motion } from "framer-motion";
// import { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import loginImg from "../assets/images/amass-pros-login-img.webp";
// import "./RegisterOtp.css";
// import "./AuthResponsive.css";

// export default function RegisterOtp() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const inputRefs = useRef([]);
//   const otpNotice =
//     location.state?.otpNotice ||
//     "OTP sent to your registered mobile number. Please enter the code to proceed.";

//   const goDashboard = () => {
//     window.open("https://amasspros.in/", "_blank", "noopener,noreferrer");
//   };

//   const isOtpComplete = (values) => values.join("").length === 4;
//   const goHome = () => {
//     navigate("/", { replace: true });
//   };

//   useEffect(() => {
//     const onPopState = () => {
//       navigate("/register", { replace: true });
//     };

//     window.addEventListener("popstate", onPopState);
//     return () => window.removeEventListener("popstate", onPopState);
//   }, [navigate]);
//   const goRegister = () => {
//     navigate("/register", { replace: true });
//   };

//   const handleChange = (index, value) => {
//     const digit = value.replace(/\D/g, "").slice(-1);
//     const next = [...otp];
//     next[index] = digit;
//     setOtp(next);

//     if (digit && index < 3) {
//       inputRefs.current[index + 1]?.focus();
//     }
//     if (isOtpComplete(next)) {
//       goHome();
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       inputRefs.current[index - 1]?.focus();
//     }
//   };

//   const handlePaste = (e) => {
//     e.preventDefault();
//     const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4);
//     if (!pasted) return;

//     const next = ["", "", "", ""];
//     for (let i = 0; i < pasted.length; i += 1) {
//       next[i] = pasted[i];
//     }
//     setOtp(next);

//     if (pasted.length < 4) {
//       inputRefs.current[pasted.length]?.focus();
//       return;
//     }
//     goHome();
//   };

//   const handleSubmit = () => {
//     if (!isOtpComplete(otp)) {
//       window.alert("Please enter valid 4-digit OTP.");
//       return;
//     }
//     goDashboard();
//   };

//   return (
//     <div className="auth-page otp-page">
//       <div className="auth-container otp-auth-container">
//         <div className="auth-left">
//         <motion.div
//           className="otp-heading"
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <h1>Verify Your Phone</h1>
//           <p>Enter the OTP sent to your phone number</p>
//         </motion.div>
//         <div className="otp-notice-box" role="status" aria-live="polite">
//           {otpNotice}
//           <span className="otp-note-sub">4-digit code</span>
//         </div>

//         <div className="otp-wrapper">
//           {otp.map((digit, index) => (
//             <input
//               key={index}
//               ref={(el) => { inputRefs.current[index] = el; }}
//               className="otp-input"
//               maxLength="1"
//               value={digit}
//               onChange={(e) => handleChange(index, e.target.value)}
//               onKeyDown={(e) => handleKeyDown(index, e)}
//               onPaste={handlePaste}
//               onFocus={(e) => e.target.select()}
//               inputMode="numeric"
//               autoFocus={index === 0}
//             />
//           ))}
//         </div>

//         <motion.button
//           whileHover={{ scale: 1.02 }}
//           whileTap={{ scale: 0.98 }}
//           onClick={handleSubmit}
//           className="btn"
//         >
//           Submit
//         </motion.button>

//         <p className="resend-text">
//           Didn't receive code?{" "}
//           <span className="resend-link" onClick={goRegister}>
//             Resend
//           </span>
//         </p>

//         <button type="button" onClick={goRegister} className="otp-back-btn">
//           Back
//         </button>
//       </div>

//         <div className="auth-right">
//           <img src={loginImg} alt="OTP" className="login-image" />
//         </div>
//       </div>
//     </div>
//   );
// }
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import loginImg from "../assets/images/amass-pros-login-img.webp";
import "./RegisterOtp.css";
import "./AuthResponsive.css";

const OTP_START_API = "http://localhost:8080/api/auth/otp/start";
const OTP_VERIFY_API = "http://localhost:8080/api/auth/otp/verify";

export default function RegisterOtp() {
  const navigate = useNavigate();
  const location = useLocation();

  const phoneNumber =
    location.state?.phoneNumber ||
    location.state?.user?.phone ||
    localStorage.getItem("phoneNumber") ||
    "";

  const otpNotice =
    location.state?.otpNotice ||
    "OTP sent to your registered mobile number. Please enter the code to proceed.";

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const inputRefs = useRef([]);

  const isOtpComplete = (values) => values.join("").length === 4;

  const goHome = () => {
    navigate("/", { replace: true });
  };

  const goRegister = () => {
    navigate("/register", { replace: true });
  };

  useEffect(() => {
    const onPopState = () => {
      navigate("/register", { replace: true });
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [navigate]);

  useEffect(() => {
    if (!phoneNumber) return;

    sendOtp();
    setTimeout(() => {
      inputRefs.current[0]?.focus();
    }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneNumber]);

  const sendOtp = async () => {
    if (!phoneNumber) {
      await Swal.fire({
        icon: "warning",
        title: "Phone Number Missing",
        text: "Phone number not found. Please register again.",
        confirmButtonColor: "#f97316",
      });
      return;
    }

    try {
      setSending(true);

      const res = await axios.post(
        OTP_START_API,
        { phone: phoneNumber },
        {
          headers: { "Content-Type": "application/json" },
          timeout: 20000,
        }
      );

      const demoOtp = res?.data?.otp;
      const message = res?.data?.message || "OTP sent successfully.";

      await Swal.fire({
        icon: "success",
        title: "OTP Sent",
        html: demoOtp
          ? `<b>${message}</b><br/><br/>Demo OTP: <b>${demoOtp}</b>`
          : `<b>${message}</b><br/><br/>Please check your registered mobile number.`,
        confirmButtonText: "OK",
        confirmButtonColor: "#16a34a",
      });
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "OTP send failed. Please try again.";

      await Swal.fire({
        icon: "error",
        title: "OTP Send Failed",
        text: msg,
        confirmButtonText: "Try Again",
        confirmButtonColor: "#ef4444",
      });
    } finally {
      setSending(false);
    }
  };

  const handleChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    const next = [...otp];
    next[index] = digit;
    setOtp(next);

    if (digit && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const next = [...otp];
        next[index] = "";
        setOtp(next);
        return;
      }

      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 4);

    if (!pasted) return;

    const next = ["", "", "", ""];
    for (let i = 0; i < pasted.length; i += 1) {
      next[i] = pasted[i];
    }
    setOtp(next);

    if (pasted.length < 4) {
      inputRefs.current[pasted.length]?.focus();
    } else {
      inputRefs.current[3]?.focus();
    }
  };

  const handleSubmit = async () => {
    const joinedOtp = otp.join("");

    if (!phoneNumber) {
      await Swal.fire({
        icon: "warning",
        title: "Phone Number Missing",
        text: "Phone number not found. Please register again.",
        confirmButtonColor: "#f97316",
      });
      return;
    }

    if (!isOtpComplete(otp)) {
      await Swal.fire({
        icon: "warning",
        title: "Invalid OTP",
        text: "Please enter valid 4-digit OTP.",
        confirmButtonColor: "#f97316",
      });
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        OTP_VERIFY_API,
        {
          phone: phoneNumber,
          otp: joinedOtp,
        },
        {
          headers: { "Content-Type": "application/json" },
          timeout: 20000,
        }
      );

      const msg =
        res?.data?.message ||
        "OTP verified successfully. Your registration has been completed.";

      await Swal.fire({
        icon: "success",
        title: "Verification Successful",
        html:
          "<b>Your registration has been completed successfully.</b><br/><br/>" +
          msg,
        confirmButtonText: "Continue",
        confirmButtonColor: "#16a34a",
        allowOutsideClick: false,
      });

      goHome();
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "OTP verification failed. Please try again.";

      await Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: msg,
        confirmButtonText: "Try Again",
        confirmButtonColor: "#ef4444",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page otp-page">
      <div className="auth-container otp-auth-container">
        <div className="auth-left">
          <motion.div
            className="otp-heading"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Verify Your Phone</h1>
            <p>Enter the OTP sent to your phone number</p>
          </motion.div>

          <div className="otp-notice-box" role="status" aria-live="polite">
            {otpNotice}
            {phoneNumber ? <span className="otp-note-sub">{phoneNumber}</span> : null}
          </div>

          <div className="otp-wrapper">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => {
                  inputRefs.current[index] = el;
                }}
                className="otp-input"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={handlePaste}
                onFocus={(e) => e.target.select()}
                inputMode="numeric"
                autoFocus={index === 0}
              />
            ))}
          </div>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleSubmit}
            className="btn"
            type="button"
            disabled={loading}
          >
            {loading ? "Verifying..." : "Submit"}
          </motion.button>

          <p className="resend-text">
            Didn't receive code?{" "}
            <span
              className="resend-link"
              onClick={!sending ? sendOtp : undefined}
              style={{ cursor: sending ? "not-allowed" : "pointer" }}
            >
              {sending ? "Sending..." : "Resend"}
            </span>
          </p>

          <button type="button" onClick={goRegister} className="otp-back-btn">
            Back
          </button>
        </div>

        <div className="auth-right">
          <img src={loginImg} alt="OTP" className="login-image" />
        </div>
      </div>
    </div>
  );
}
